import moment from 'moment'

export default {
   methods: {
      formatMoney(val) {
         return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      formatPhone(val) {
         if (!val) return ''
         return ('0' + val).replace(/\D*(\d{3})\D*(\d{4})\D*(\d{4})\D*/, '$1 $2 $3')
      },
      formatNumber(value) {
         return Number(value || 0).toLocaleString('en-US', {
            maximumFractionDigits: 0
         })
      },
      /**
       * Extracts value and unit from a string or number.
       * If the input is a number, it returns an object with the value.
       * If the input is a string with a number followed by a unit, it returns an object with the value and unit.
       *
       * @param {string|number} val - The input string or number.
       * @returns {{ value: string, unit?: string }} An object containing the value and optional unit.
       */
      extractValueAndUnit(val) {
         if (typeof val === 'number') {
            return { value: this.formatNumber(val) }
         }

         if (typeof val === 'string') {
            const regex = /^(\d+)(\s*[a-zA-Z]+)?$/
            const match = val.match(regex)

            if (match) {
               const value = this.formatNumber(parseFloat(match[1]))
               const unit = match[2] ? match[2].trim() : undefined
               return unit ? { value, unit } : { value }
            }
         }

         return { value: '0' }
      },
      /**
       * Formats a given date into a specified format.
       * Supported format: 'DD/MM/YYYY'.
       *
       * @param {Date|string|number} date - The date to format, can be a Date object, a timestamp, or a date string.
       * @returns {string} The formatted date string.
       */
      formatToDate(date) {
         return moment(date).format('DD/MM/YYYY')
      },
      /**
       * Formats a given date into a specified format.
       * Supported format: 'DD/MM/YYYY HH:mm:ss'.
       *
       * @param {Date|string|number} date - The date to format, can be a Date object, a timestamp, or a date string.
       * @returns {string} The formatted date string.
       */
      formatToDateTime(date) {
         return moment(date).format('DD/MM/YYYY HH:mm:ss')
      }
   }
}
